// @flow
import * as React from 'react';
import classNames from 'classnames';

import Badge from 'sail/Badge';
import Box from 'sail/Box';
import DataTable, {
  DataTableBody,
  DataTableCell,
  DataTableHead,
  DataTableRow,
} from 'sail/DataTable';
import {Caption, BodyMono} from 'sail/Text';
import './TailorPropsTable.scss';

type TailorPropsTableProps = {|
  component: string,
  propInfo: any,
|};

// This is very similar to MarkdocAttributeReference.js - since this component is expected to
// go through a lot of change, I thought duplicating code made more sense before
// trying to find the correct abstractions.

type DefaultValueProps = {|
  defaultValue: React.Node,
|};

const DefaultValue = ({defaultValue}: DefaultValueProps): React.Node => {
  if (!defaultValue) {
    return <BodyMono color="disabled">none</BodyMono>;
  }

  return <BodyMono color="blue">{defaultValue}</BodyMono>;
};

export const TailorPropsTable = ({
  component,
  propInfo,
}: TailorPropsTableProps) => {
  const props = propInfo.props;
  const rows = (Object.entries(props): any).map(([name, attr], index) => {
    let descriptionRow = null;
    if (attr.description) {
      descriptionRow = (
        <DataTableRow key={`${name}-description`}>
          <DataTableCell colSpan={3}>
            <Caption color="gray">{attr.description}</Caption>
          </DataTableCell>
        </DataTableRow>
      );
    }
    const attributeRow = (
      <DataTableRow
        key={name}
        className={classNames({
          'TailorPropsTable-TableRow-hasDescription': !!descriptionRow,
        })}
      >
        <DataTableCell width={200} emphasized wrap={false}>
          <Box>
            <BodyMono>{name} </BodyMono>
            {attr.required && <Badge variant="tag" label="Required" />}
          </Box>
        </DataTableCell>
        <DataTableCell>{attr.type ? attr.type.name : 'unknown'}</DataTableCell>
        <DataTableCell width={200}>
          <DefaultValue defaultValue={attr.defaultValue} />
        </DataTableCell>
      </DataTableRow>
    );

    return [attributeRow, descriptionRow];
  });

  return (
    <DataTable className="TailorPropsTable" size="small">
      <DataTableHead
        columns={[{label: 'Name'}, {label: 'Type'}, {label: 'Default value'}]}
      />
      <DataTableBody>{rows}</DataTableBody>
    </DataTable>
  );
};
